<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailGroupOrderInfo.groupOrders"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="orderId" :label="$t('productGroupOrderManage.orderId')" align="center" />
        <el-table-column :label="$t('productGroupOrderManage.productImage')" align="center">
          <template #default="{row}">
            <div style="position: relative; display: inline-block;">
              <el-image
                width="50"
                height="50"
                style="border-radius: 10px;"
                :src="row.coverPhoto"
                v-if="row.coverPhoto"
              />
              <el-image
                width="50"
                height="50"
                style="border-radius: 10px;"
                src="/img/noPhoto.jpg"
                v-else
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('productGroupOrderManage.productName')" align="center">
          <template #default="{row}">
            【{{row.userCount}}人团】{{row.prodName}}
          </template>
        </el-table-column>
        <el-table-column prop="buyerName" :label="$t('productGroupOrderManage.buyer')" align="center" />
        <el-table-column prop="groupBuyerName" :label="$t('productGroupOrderManage.groupLeader')" align="center" />
        <el-table-column prop="buyerCount" :label="$t('productGroupOrderManage.purchaseQuantity')" align="center" />
        <el-table-column :label="$t('productGroupOrderManage.groupSize')" align="center">
          <template #default="{row}">
            {{row.groupCount}}/{{row.userCount}}
          </template>
        </el-table-column>
        <el-table-column prop="groupPrice" :label="$t('productGroupOrderManage.groupAmount')" align="center" />
        <el-table-column prop="stateName" :label="$t('productGroupOrderManage.status')" align="center" />
        <el-table-column prop="rebateAmount" :label="$t('productGroupOrderManage.rebateAmount')" align="center" />
        <el-table-column prop="openTime" :label="$t('productGroupOrderManage.openTime')" align="center" />
        <el-table-column prop="createTime" :label="$t('productGroupOrderManage.groupTime')" align="center" />
        <el-table-column prop="endTime" :label="$t('productGroupOrderManage.deadline')" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listProductGroupOrder } from '@/api/goods/productDetailApi'
export default {
  name: 'ProductDetailGroupOrder',
  data() {
    return {
      productDetailGroupOrderInfo: {
        groupOrders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailGroupOrderInfo.productId = params.productId
      this.loadProductDetailGroupOrderData()
    },
    async loadProductDetailGroupOrderData() {
      const res = await listProductGroupOrder({
          productId: this.productDetailGroupOrderInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })
      this.productDetailGroupOrderInfo.groupOrders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailGroupOrderData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>